<template>
  <slot></slot>
</template>

<script>
import $ from "jquery";

export default {
  name: "ModalWarper",
  emits: ["close"],
  props: {
    target: {
      type: String,
      default: "idModalDefault",
    },
    show: {
      type: Boolean,
      default: false,
    },
    keyboard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      BSModal: null,
      BSModalEl: null,
      // modalCount: 0
    };
  },
  watch: {
    show(open) {
      if (!this.BSModal) {
        return;
      }

      if (open) {
        this.BSModal.show();
      } else {
        this.BSModal.hide();
      }
    },
  },
  mounted() {
    // this.modalCount = 0;
    this.initModal();
  },
  methods: {
    escKeyHandler(event) {
      // console.log(event);

      if (event.keyCode === 27) {
        this.$emit("close", true);
      }
    },
    initModal() {
      this.$nextTick(() => {
        if (this.BSModalEl) return;

        this.BSModalEl = document.getElementById(this.target);

        this.BSModal = new window.bootstrap.Modal(this.BSModalEl, {
          keyboard: true,
          focus: true,
        });

        this.BSModalEl.addEventListener("keydown", this.escKeyHandler);

        if (this.show) {
          this.BSModal.show();
        }

        this.BSModalEl.addEventListener("hidden.bs.modal", (event) => {
          if (event.target == event.currentTarget) {
            this.$emit("close", true);
            return true;
          }
          return false;
        });

        // this.BSModalEl.addEventListener('show.bs.modal', () => {
        //     const focusElement = this.BSModalEl.querySelector(`#focusId-${this.modalCount}`);
        //     if (focusElement) {
        //         focusElement.focus();
        //     }
        // });

        // document.addEventListener('keydown', (event) => {
        //     if (event.key === 'Escape' && this.BSModal && this.BSModal._isShown) {
        //         this.BSModal.hide();
        //     }
        // });

        // let currentModal = null;

        // this.BSModalEl.addEventListener('show.bs.modal', () => {
        //     currentModal = this.BSModal;
        // });

        // this.BSModalEl.addEventListener('hidden.bs.modal', () => {
        //     currentModal = null;
        // });

        // // Adicione este ouvinte de evento para a tecla Esc
        // document.addEventListener('keydown', (event) => {
        //     console.log(currentModal);
        //     if (event.key === 'Escape' && currentModal) {
        //         currentModal.hide();
        //     }
        // });
      });
      // this.modalCount++;
    },
  },
};
</script>

<style scoped lang="scss"></style>
